import { BasicContent } from './BasicContent';
import RichText from './RichText';
import ProCatCalculator from '../../Insulation/ProCatCalculator/ProCatCalculator';

const CMSProCatCalculator = ({ content, calculator }) => (
  <>
    <BasicContent {...content.copy} />
    <ProCatCalculator
      costPerBag={calculator.costPerBag}
      installers={calculator.installers}
      laborRate={calculator.laborRate}
      markup={calculator.markup}
      footnotes={<RichText content={calculator.footnotes} />}
    />
  </>
);

export default CMSProCatCalculator;
